import {PerformanceLogger} from '../performance';
import {ENVIRONMENT_LEVEL} from '@/Constant';

export class Comment {

    key = 'Comment';

    logger: PerformanceLogger;

    constructor(logger: PerformanceLogger) {
        this.logger = logger;
    }

    logWeb =({id, data}: {id: string, data?: any}) => {
        const logger = this.logger;
        const logLevel = logger?.logLevel || '';
        if ([ENVIRONMENT_LEVEL.online, ENVIRONMENT_LEVEL.gray, ENVIRONMENT_LEVEL.qa].includes(logLevel)) {
            const opVersion = logger?.getOpVersionInfo();
            logger.feLogger({
                id,
                data: {
                    ...data,
                    opVersion,
                },
            });
        }
    };

    comment() {
        this.logWeb({
            id: '80001.2.31',
        });
    }

    commentSuccess() {
        // 因已由业务上报 不再上报成功埋点
        // this.logWeb({
        //     id: '80001.8.33',
        // });
    }

    commentError() {
        this.logWeb({
            id: '80001.2.32',
        });
    }


}
